module.exports = require("./hsb-DE.js");